export const common = {
  // Navigation
  home: 'الرئيسية',
  cars: 'السيارات',
  agencies: 'الوكالات',
  brands: 'العلامات التجارية',
  about: 'حولنا',
  contact: 'اتصل بنا',
  signIn: 'تسجيل الدخول',
  signUp: 'التسجيل',
  login: 'تسجيل الدخول',
  signup: 'التسجيل',
  dashboard: 'لوحة التحكم',
  dashboardNav: 'لوحة التحكم',
  logout: 'تسجيل الخروج',
  myAccount: 'حسابي',
  
  // Location search
  location: 'الموقع',
  pickupDate: 'تاريخ الاستلام',
  returnDate: 'تاريخ الإرجاع',
  selectDates: 'اختر التواريخ',
  day: 'يوم',
  time: 'الوقت',
  from: 'ابتداءً من',
  
  // Homepage content
  findBookRental: 'ابحث، احجز، استأجر',
  easySteps: 'خطوات سهلة',
  getCarWherever: 'احصل على سيارة في أي مكان',
  howItWork: 'كيف يعمل',
  rentWithSteps: 'استأجر في 3 خطوات سهلة',
  whyChooseUs: 'لماذا تختارنا',
  bestExperienceRental: 'أفضل تجربة تأجير',
  popularRentalDeals: 'عروض التأجير الشائعة',
  mostPopularCars: 'السيارات الأكثر شعبية',
  rent: 'استأجر',
  showAllVehicles: 'عرض جميع المركبات',
  testimonials: 'الشهادات',
  whatPeopleSay: 'ما يقوله الناس',
  
  // Steps
  chooseLocation: 'اختر الموقع',
  chooseLocationDesc: 'اختر موقع الاستلام',
  pickupDateDesc: 'اختر تاريخ الاستلام',
  bookYourCar: 'احجز سيارتك',
  bookYourCarDesc: 'أكمل حجزك',
  
  // Benefits
  bestPriceGuaranteed: 'أفضل سعر مضمون',
  bestPriceGuaranteedDesc: 'نقدم أفضل الأسعار',
  experienceDriver: 'سائق محترف',
  experienceDriverDesc: 'سائقون محترفون',
  carDelivery24h: 'توصيل السيارة 24 ساعة',
  carDelivery24hDesc: 'خدمة توصيل على مدار الساعة',
  technicalSupport247: 'دعم فني 24/7',
  technicalSupport247Desc: 'دعم مستمر',
  
  // Common actions
  search: 'بحث',
  filter: 'تصفية',
  book: 'احجز',
  cancel: 'إلغاء',
  confirm: 'تأكيد',
  save: 'حفظ',
  saveChanges: 'حفظ التغييرات',
  saving: 'جاري الحفظ...',
  saved: 'تم الحفظ بنجاح',
  refresh: 'تحديث',
  edit: 'تعديل',
  delete: 'حذف',
  loading: 'جاري التحميل...',
  unknownError: 'خطأ غير معروف',
  submit: 'إرسال',
  close: 'إغلاق',
  back: 'رجوع',
  next: 'التالي',
  clear: 'مسح',
  change: 'تغيير',
  manageColumns: 'إدارة الأعمدة',
  selectColumnsToDisplay: 'حدد الأعمدة التي تريد عرضها في الجدول',
  resetDefault: 'إعادة تعيين افتراضي',
  previous: 'السابق',
  yes: 'نعم',
  no: 'لا',
  ok: 'موافق',
  optional: 'اختياري',
  none: 'لا يوجد',
  amount: 'المبلغ',
  noLocationsFound: 'لم يتم العثور على مواقع',
  goBack: 'العودة',
  user: 'المستخدم',
  
  // Status
  status: 'الحالة',
  active: 'نشط',
  inactive: 'غير نشط',
  pending: 'في الانتظار',
  confirmed: 'مؤكد',
  completed: 'مكتمل',
  cancelled: 'ملغي',
  
  // Signup Section
  joinKiraCar: 'انضم إلى كيرا كار',
  chooseYourPath: 'اختر طريقك وابدأ رحلتك مع أفضل منصة لتأجير السيارات',
  becomeClient: 'كن عميلاً',
  clientDescription: 'استأجر السيارات بسهولة وسرعة. احصل على مجموعة واسعة من المركبات المتاحة بالقرب منك.',
  signupAsClient: 'التسجيل كعميل',
  becomeAgency: 'كن وكالة',
  agencyDescription: 'أدرج أسطولك وطور أعمال التأجير الخاصة بك',
  signupAsAgency: 'التسجيل كوكالة',
  
  // Time
  today: 'اليوم',
  yesterday: 'أمس',
  tomorrow: 'غداً',
  thisMonth: 'هذا الشهر',
  last7Days: 'آخر 7 أيام',
  last30Days: 'آخر 30 يوماً',
  allPeriod: 'جميع الفترات',
  customPeriod: 'فترة مخصصة',
  customPeriodEllipsis: 'فترة مخصصة...',
  selectCustomPeriod: 'اختيار فترة مخصصة',
  startDate: 'تاريخ البداية',
  endDate: 'تاريخ النهاية',
  pickDate: 'اختر تاريخاً',
  apply: 'تطبيق',
  minute: 'دقيقة',
  minutes: 'دقائق',
  hour: 'ساعة',
  hours: 'ساعات',
  days: 'أيام',
  week: 'أسبوع',
  weeks: 'أسابيع',
  month: 'شهر',
  months: 'أشهر',
  year: 'سنة',
  years: 'سنوات',
  
  // Common phrases
  noDataFound: 'لم يتم العثور على بيانات',
  tryAgain: 'حاول مرة أخرى',
  somethingWentWrong: 'حدث خطأ ما',
  pleaseWait: 'يرجى الانتظار...',
  
  // Languages
  english: 'English',
  french: 'Français',
  arabic: 'العربية',
  
  // Common statuses
  available: 'متاح',
  unavailable: 'غير متاح',
  
  // Common
  view: 'عرض',
  welcome: 'مرحباً',
  error: 'حدث خطأ',
  retry: 'إعادة المحاولة',
  
  // Error and Alert Messages
  warning: 'تحذير',
  info: 'معلومات',
  
  // Booking Alerts
  failedToCancelBooking: 'فشل في إلغاء الحجز. يرجى المحاولة مرة أخرى.',
  pleaseSelectDates: 'يرجى تحديد تواريخ الاستلام والإرجاع',
  failedToCreateBooking: 'فشل في إنشاء الحجز. يرجى المحاولة مرة أخرى.',
  carNotFound: 'السيارة غير موجودة',
  backToCars: 'العودة إلى السيارات',
  
  // Location Management Alerts
  locationTableNotExists: 'جدول agency_locations غير موجود بعد. يرجى تشغيل السكريبت SQL المقدم في complete_location_system_setup.sql',
  databaseError: 'خطأ في قاعدة البيانات: {{message}}. الكود: {{code}}',
  errorSavingLocation: 'خطأ في حفظ الموقع. راجع وحدة التحكم للمزيد من التفاصيل.',
  errorSettingDefaultLocation: 'خطأ في تعيين الموقع الافتراضي. راجع وحدة التحكم للمزيد من التفاصيل.',
  
  // Contract Alerts
  errorDownloadingContract: 'خطأ في تحميل العقد',
  errorPrintingContract: 'خطأ في طباعة العقد',
  
  // Booking
  booking: {
    contactInfo: 'معلومات الاتصال',
    contactInfoDescription: 'يرجى تقديم تفاصيل الاتصال الخاصة بك لإتمام الحجز',
    confirmBooking: 'تأكيد الحجز',
    processing: 'جاري المعالجة...',
    bookingCreated: 'تم إنشاء الحجز!',
    agencyWillContactYou: 'ستتصل بك الوكالة قريبًا عبر واتساب',
    keepPhoneAvailable: 'يرجى إبقاء هاتفك متاحًا',
    bookingDetails: 'تفاصيل الحجز',
    bookingId: 'رقم الحجز',
    createAccountBenefit: '🎁 أنشئ حسابًا لتتبع حجوزاتك!',
    trackAllBookings: 'تتبع جميع حجوزاتك في مكان واحد',
    viewHistory: 'عرض السجل والإيصالات',
    fasterNextTime: 'احجز بشكل أسرع في المرة القادمة',
    manageProfile: 'إدارة ملفك الشخصي وتفضيلاتك',
    createAccountNow: 'إنشاء حساب الآن',
    maybeLater: 'ربما لاحقًا',
    createYourAccount: 'أنشئ حسابك',
    accountPreFilled: 'تم ملء معلومات الاتصال الخاصة بك بالفعل',
    skipForNow: 'تخطي الآن',
    goToDashboard: 'الذهاب إلى لوحة التحكم',
  },

  // Authentication
  auth: {
    fullName: 'الاسم الكامل',
    enterFullName: 'أدخل اسمك الكامل',
    phone: 'الهاتف',
    enterPhone: 'أدخل رقم هاتفك',
    email: 'البريد الإلكتروني',
    enterEmail: 'أدخل عنوان بريدك الإلكتروني',
    password: 'كلمة المرور',
    enterPassword: 'أدخل كلمة المرور',
    passwordMinLength: 'الحد الأدنى 6 أحرف',
    passwordTooShort: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
    invalidEmail: 'تنسيق البريد الإلكتروني غير صالح',
    createAccount: 'إنشاء حساب',
    creatingAccount: 'جاري إنشاء الحساب...',
    accountCreated: 'تم إنشاء الحساب!',
    accountCreatedSuccess: 'تم إنشاء حسابك بنجاح. يمكنك الآن تتبع حجوزاتك وإدارة ملفك الشخصي.',
    login: 'تسجيل الدخول',
    alreadyHaveAccount: 'هل لديك حساب بالفعل؟',
  },
  
  // Customer Management
  failedToDeleteCustomer: 'فشل في حذف العميل: {{message}}',
  areYouSureYouWantToDeleteThisCustomer: 'هل أنت متأكد من أنك تريد حذف هذا العميل؟ لا يمكن التراجع عن هذا الإجراء.',
  
  // Vehicle Management
  failedToUploadImage: 'فشل في رفع الصورة: {{fileName}}\\nالخطأ: {{error}}',
  searchVehicle: 'البحث عن مركبة...',
  
  // Profile Settings
  profile: {
    profile: 'الملف الشخصي',
    security: 'الأمان',
    preferences: 'التفضيلات',
    account: 'الحساب',
    personalInfo: 'المعلومات الشخصية',
    personalInfoDescription: 'قم بتحديث بياناتك الشخصية ومعلومات الاتصال',
    subtitle: 'إدارة إعدادات وتفضيلات حسابك',
    fullName: 'الاسم الكامل',
    fullNamePlaceholder: 'أدخل اسمك الكامل',
    email: 'عنوان البريد الإلكتروني',
    emailCannotChange: 'لا يمكن تغيير عنوان البريد الإلكتروني لأسباب أمنية',
  profilePicture: 'صورة الملف الشخصي',
    phone: 'رقم الهاتف',
    phonePlaceholder: 'أدخل رقم هاتفك',
    role: 'الدور',
    roles: {
      admin: 'مدير',
      agency: 'وكالة',
      customer: 'عميل'
    },
    verified: 'مُتحقق',
    noPhone: 'لا يوجد رقم هاتف',
    avatarHelp: 'انقر لتحميل صورة ملف شخصي جديدة',
    changePassword: 'تغيير كلمة المرور',
    passwordHelp: 'قم بتحديث كلمة المرور للحفاظ على أمان حسابك',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    updatePassword: 'تحديث كلمة المرور',
    fillAllFields: 'يرجى ملء جميع حقول كلمة المرور',
    passwordMismatch: 'كلمات المرور الجديدة غير متطابقة',
    passwordTooShort: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
    passwordChanged: 'تم تحديث كلمة المرور بنجاح',
    passwordUpdateFailed: 'فشل في تحديث كلمة المرور',
    currentPasswordRequired: 'كلمة المرور الحالية مطلوبة',
    newPasswordRequired: 'كلمة المرور الجديدة مطلوبة',
    confirmPasswordRequired: 'يرجى تأكيد كلمة المرور الجديدة',
    incorrectCurrentPassword: 'كلمة المرور الحالية غير صحيحة',
    fullNameRequired: 'الاسم الكامل مطلوب',
    invalidPhone: 'رقم الهاتف غير صحيح',
    language: 'اللغة',
    languageHelp: 'اختر لغتك المفضلة',
    theme: 'المظهر',
    themeHelp: 'اختر مظهرك المفضل',
    lightMode: 'المظهر الفاتح',
    darkMode: 'المظهر الداكن',
    systemMode: 'النظام',
    notificationHelp: 'فعّل إشعارات المتصفح لتلقي تحديثات فورية حول الحجوزات والمدفوعات وصيانة المركبات.',
    accountInfo: 'معلومات الحساب',
    memberSince: 'عضو منذ',
    lastUpdated: 'آخر تحديث',
    notFound: 'الملف الشخصي غير موجود'
  },
  
  // Contracts
  contracts: {
    title: 'إدارة العقود',
    subtitle: 'إنشاء وإدارة عقود الإيجار الخاصة بك',
    createContract: 'إنشاء عقد',
    createFirstContract: 'إنشاء عقدك الأول',
    generateContract: 'إنتاج العقد',
    contractPreview: 'معاينة العقد',
    preview: 'معاينة',
    download: 'تحميل',
    searchPlaceholder: 'البحث برقم العقد، العميل...',
    noContracts: 'لم يتم العثور على عقود',
    noContractsDesc: 'ابدأ بإنشاء عقد الإيجار الأول',
    noContractsFound: 'لم يتم العثور على عقود',
    tryDifferentSearch: 'جرب بحثاً مختلفاً',
    selectBooking: 'اختر حجزاً لإنشاء عقد',
    noBookingsAvailable: 'لا توجد حجوزات مؤكدة متاحة',
    createdOn: 'تم الإنشاء في',
    totalAmount: 'المبلغ الإجمالي',
    signed: 'موقع',
    pending: 'في الانتظار',
    contractNumber: 'رقم العقد',
    client: 'العميل',
    vehicle: 'المركبة',
    period: 'الفترة',
    amount: 'المبلغ',
    creationDate: 'تاريخ الإنشاء',
    status: 'الحالة',
    actions: 'الإجراءات',
    deposit: 'التأمين',
    to: 'إلى',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    date: 'التاريخ',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    agencyRepresentative: 'ممثل الوكالة',
    renter: 'المستأجر',
    rentalPeriod: 'فترة الإيجار',
    financialTerms: 'الشروط المالية',
    signatureAgreement: 'بالتوقيع أدناه، يوافق الطرفان على الشروط والأحكام المذكورة أعلاه.',
    totalRentalAmount: 'إجمالي مبلغ الإيجار',
    depositAmount: 'مبلغ التأمين',
    make: 'الماركة',
    model: 'الموديل',
    year: 'السنة',
    color: 'اللون',
    rentalAgreement: 'عقد الإيجار',
    vehicleDetails: 'تفاصيل المركبة',
    termsAndConditions: 'الشروط والأحكام',
    agency: 'الوكالة',
    renterName: 'المستأجر',
    agreementBetween: 'يُبرم هذا الاتفاق بين',
    and: 'و',
    clientContact: 'معلومات الاتصال بالعميل',
    fullName: 'الاسم الكامل',
  },
  
  // Date Range Selector
  selectPeriod: 'اختر فترة',
  selectAPeriod: 'اختر فترة',
  selectDate: 'اختر تاريخ',
  selectTime: 'اختر وقت',
  
  // Booking Timeline Calendar
  selectStatus: 'اختر الحالة',
  bookingDetails: 'تفاصيل الحجز',
  pickupTime: 'وقت الاستلام',
  returnTime: 'وقت الإرجاع',
  timeCaption: 'الوقت',
  notSpecified: 'غير محدد',
  
  // Labels
  vehicle: 'المركبة',
  vehicles: 'المركبات',
  vehicleAvailable: 'مركبة متاحة',
  vehiclesAvailable: 'مركبات متاحة',
  category: 'فئة',
  categories: 'فئات',
  bookingCalendar: 'تقويم الحجوزات',
  
  // Date formatting
  invalidFormat: 'تنسيق غير صالح',
  dateError: 'خطأ في التاريخ',
  
  // Common UI text
  unknownClient: 'عميل مجهول',
  noVehicleFound: 'لم يتم العثور على مركبات',
  noVehicleFoundFor: 'لم يتم العثور على مركبة لـ',
  
  // Pagination
  showing: 'عرض',
  to: 'إلى',
  of: 'من',
  rowsPerPage: 'صفوف لكل صفحة',
  
  // Customer info
  customerInformation: 'معلومات العميل',
  idNumber: 'رقم الهوية',
  phoneLabel: 'هاتف',
  vehicleNotFound: 'المركبة غير موجودة',
  
  // File upload errors
  invalidFileType: 'نوع ملف غير صالح. يرجى رفع ملف صورة.',
  fileTooLarge: 'الملف كبير جداً. يرجى رفع صورة أصغر من 5 ميجابايت.',
  logoUploadError: 'فشل في رفع الشعار',
  
  // Additional booking keys
  totalPrice: 'إجمالي السعر',
  paymentStatus: 'حالة الدفع',
  paid: 'مدفوع',
  unpaid: 'غير مدفوع',
  notes: 'ملاحظات',
  noNotes: 'لا توجد ملاحظات',
  notesPlaceholder: 'أضف ملاحظات...',
  pickupLocation: 'موقع الاستلام',
  returnLocation: 'موقع الإرجاع',
  selectVehicle: 'اختر مركبة',
  
  // Notifications
  notifications: {
    title: 'الإشعارات',
    empty: 'لا توجد إشعارات بعد',
    emptyDescription: 'عندما تحصل على تحديثات جديدة، ستظهر هنا',
    unreadCount: '{{count}} إشعار غير مقروء',
    markAsRead: 'تحديد كمقروء',
    markAllRead: 'تحديد الكل كمقروء',
    dismiss: 'تجاهل',
    types: {
      booking: 'حجز',
      maintenance: 'صيانة',
      insurance: 'تأمين',
      payment: 'دفع',
      system: 'نظام'
    },
    priorities: {
      normal: 'عادي',
      important: 'مهم',
      urgent: 'عاجل'
    },
    templates: {
      pickupReminder: {
        title: 'تذكير بالاستلام - {{carMake}} {{carModel}}',
        message: 'العميل {{customerName}} مجدول لاستلام المركبة خلال 4 ساعات.'
      },
      returnReminder: {
        title: 'تذكير بالإرجاع - {{carMake}} {{carModel}}',
        message: 'العميل {{customerName}} مجدول لإرجاع المركبة خلال ساعتين.'
      },
      returnOverdue: {
        title: 'تأخير في الإرجاع - {{carMake}} {{carModel}}',
        message: 'العميل {{customerName}} لم يرجع المركبة. كان الإرجاع مجدولاً في {{returnTime}}.'
      },
      returnCritical: {
        title: 'عاجل: تأخير في الإرجاع - {{carMake}} {{carModel}}',
        message: 'العميل {{customerName}} متأخر {{hoursOverdue}} ساعات في إرجاع المركبة. مطلوب إجراء فوري.'
      },
      oilChange: {
        title: 'موعد تغيير الزيت - {{carMake}} {{carModel}}',
        message: 'المركبة {{registrationNumber}} تحتاج لتغيير الزيت بحلول {{dueDate}}.'
      },
      insuranceExpiry: {
        title: 'انتهاء التأمين - {{carMake}} {{carModel}}',
        message: 'تأمين المركبة {{registrationNumber}} ينتهي في {{expiryDate}}. يرجى التجديد قريباً.'
      },
      technicalControl: {
        title: 'انتهاء المراقبة التقنية - {{carMake}} {{carModel}}',
        message: 'المراقبة التقنية للمركبة {{registrationNumber}} تنتهي في {{expiryDate}}.'
      },
      bookingCompletion: {
        title: 'يجب إكمال الحجز',
        message: 'حجز {{clientName}} مع {{carInfo}} انتهى في {{endDate}} لكن لا يزال مؤكداً. يرجى تحديث الحالة إلى مكتمل.'
      }
    }
  },
  
  // Car status management
  carStatuses: {
    updateInProgress: "جاري تحديث حالات السيارات...",
    updateComplete: "تم تحديث حالات السيارات بنجاح",
    noUpdatesNeeded: "جميع حالات السيارات محدثة",
    updatedCount: "تم تحديث {{count}} سيارة",
    automaticUpdate: "تحديث تلقائي لحالة السيارات",
    manualUpdate: "تحديث يدوي لحالة السيارات",
    errorUpdating: "خطأ في تحديث حالات السيارات"
  },
  
  // Browser notifications
  browserNotifications: {
    enable: 'تفعيل الإشعارات',
    enabled: 'تم تفعيل الإشعارات',
    permissionRequest: 'السماح لـ KiraCar بإرسال إشعارات لك للتحديثات المهمة والتنبيهات.',
    permissionGranted: 'تم تفعيل الإشعارات بنجاح!',
    permissionDenied: 'تم إلغاء الإشعارات',
    testTitle: 'تم تفعيل إشعارات KiraCar',
    testMessage: 'ستتلقى الآن إشعارات للتحديثات المهمة!',
    testSuccess: 'تم إرسال إشعار التجربة بنجاح',
    testFailed: 'فشل في إرسال إشعار التجربة',
    test: 'اختبار الإشعار'
  },
  
  // Location-related translations for LocationSuggestionSelect
  locations: {
    searchResults: 'نتائج البحث',
    popularLocations: 'المواقع الشائعة',
    noResults: 'لم يتم العثور على مواقع',
    addCustomLocation: 'إضافة موقع مخصص',
    locationName: 'اسم الموقع',
    address: 'العنوان',
    city: 'المدينة',
    addLocation: 'إضافة موقع',
    types: {
      airport: 'مطار',
      trainStation: 'محطة قطار',
      port: 'ميناء',
      mall: 'مركز تجاري',
      businessDistrict: 'حي الأعمال',
      cityCenter: 'وسط المدينة',
      city: 'مدينة',
      district: 'حي',
      landmark: 'معلم'
    }
  },
  
  searching: 'جاري البحث...',
  
  // Success messages
  success: 'نجح',
  
  // Footer
  companyDescription: 'شريكك الموثوق لخدمات تأجير السيارات المتميزة. نوفر حلول نقل موثوقة وبأسعار معقولة ومريحة.',
  quickLinks: 'روابط سريعة',
  forAgencies: 'للوكالات',
  joinAsAgency: 'انضم كوكالة',
  agencyHelp: 'مساعدة الوكالات',
  termsOfService: 'شروط الخدمة',
  privacyPolicy: 'سياسة الخصوصية',
  allRightsReserved: 'جميع الحقوق محفوظة',
  poweredByRichaDev: 'مدعوم من RichaDev',
  
  // Coming Soon
  somethingAmazing: 'شيء مذهل',
  isComingSoon: 'قادم قريباً',
  workingHardToDeliver: 'نعمل بجد لنقدم لك تجربة تأجير السيارات المثلى.',
  stayTuned: 'ترقب التحديثات!',
  comingSoon: 'قادم قريباً',
  
  // Agency Details
  agencyDetails: 'تفاصيل الوكالة',
  agencyNotFound: 'الوكالة غير موجودة',
  browseAgencies: 'تصفح الوكالات',
  businessStats: 'إحصائيات الأعمال',
  totalVehicles: 'إجمالي المركبات',
  totalCars: 'إجمالي السيارات',
  availableCars: 'السيارات المتاحة',
  totalBookings: 'إجمالي الحجوزات',
  agencyLocations: 'المواقع',
  recentVehicles: 'المركبات الحديثة',
  availableVehicles: 'المركبات المتاحة',
  noVehiclesAvailable: 'لا توجد مركبات متاحة',
  noVehiclesForBrand: 'لا توجد حالياً أي مركبة {{brand}} متاحة للكراء.',
  brandNotFound: 'العلامة التجارية غير موجودة',
  brandNotFoundDesc: 'العلامة التجارية المطلوبة غير موجودة أو لا تحتوي على مركبات متاحة.',
  backToBrands: 'العودة إلى العلامات التجارية',
  viewAllCars: 'عرض جميع السيارات',
  viewAllBrands: 'عرض جميع العلامات التجارية',
  reviews: 'تقييمات',
  discoverVehicles: 'اكتشف مجموعتنا الواسعة من المركبات واحجز تأجيرك المثالي اليوم',
  getDirections: 'الحصول على الاتجاهات',
  daysLeft: 'أيام متبقية',
  daysRemaining: 'أيام متبقية',
  viewAll: 'عرض الكل',
  showInMap: 'عرض على الخريطة',
  mobileSearch: {
    trigger: 'إلى أين؟',
    title: 'ابحث عن سيارتك المثالية',
    description: 'اختر موقعك وتواريخك للبدء.',
  },
  featuredCategories: 'الفئات المميزة',
  featuredCategoriesDesc: 'تعرف ما تبحث عنه؟ تصفح مجموعتنا الواسعة من السيارات',
  popularDestinations: 'الوجهات الشعبية',
  popularDestinationsDesc: 'اكتشف وجهاتنا الأكثر طلباً لتأجيرك القادم',
  carsFrom: 'سيارات من',
  contactInfo: 'معلومات الاتصال',
  operatingHours: 'ساعات العمل',
  viewVehicles: 'عرض المركبات',
  callNow: 'اتصل الآن',
  sendEmail: 'إرسال بريد إلكتروني',
  verified: 'موثق',
  memberSince: 'عضو منذ',
  pickupLocations: 'مواقع الاستلام',
  main: 'الرئيسي',
  closed: 'مغلق',
  
  // Days of the week
  monday: 'الاثنين',
  tuesday: 'الثلاثاء',
  wednesday: 'الأربعاء',
  thursday: 'الخميس',
  friday: 'الجمعة',
  saturday: 'السبت',
  sunday: 'الأحد',

  // Dashboard specific
  myBookings: 'حجوزاتي',
  all: 'الكل',
  bookings: 'حجوزات',
  searchBookings: 'البحث في الحجوزات...',
  quickActions: 'إجراءات سريعة',
  contactAgency: 'اتصل بالوكالة',
  downloadContract: 'تحميل العقد',
  noBookingsYet: 'لا توجد حجوزات حتى الآن',
  startExploring: 'ابدأ في استكشاف سياراتنا لإجراء حجزك الأول',
  bookNewCar: 'احجز سيارة جديدة',
  support: 'الدعم',
  viewDetails: 'عرض التفاصيل',

  // Booking Details Modal
  vehicleInformation: 'معلومات المركبة',
  agencyInformation: 'معلومات الوكالة',
  bookingTimeline: 'الجدول الزمني للحجز',
  bookingSummary: 'ملخص الحجز',
  bookingId: 'رقم الحجز',
  bookingDate: 'تاريخ الحجز',
  duration: 'المدة',
  dailyRate: 'السعر اليومي',
  pickup: 'الاستلام',
  return: 'الإرجاع',
  needHelp: 'تحتاج مساعدة؟',
  contactSupportMessage: 'إذا كان لديك أي أسئلة حول حجزك، لا تتردد في الاتصال بفريق الدعم لدينا.',
  downloadInvoice: 'تحميل الفاتورة',
  cancelBooking: 'إلغاء الحجز',
  confirmCancellation: 'تأكيد الإلغاء',
  cancelBookingConfirmation: 'هل أنت متأكد من أنك تريد إلغاء حجزك لـ {{car}} في {{agency}}؟ لا يمكن التراجع عن هذا الإجراء.',
  keepBooking: 'الاحتفاظ بالحجز',
  confirmDeletion: 'تأكيد الحذف',
  deleteBookingConfirmation: 'هل أنت متأكد من أنك تريد حذف حجزك نهائياً لـ {{car}} في {{agency}}؟ لا يمكن التراجع عن هذا الإجراء.',
  failedToDeleteBooking: 'فشل في حذف الحجز',
  
  // Driver Information
  driverInformation: 'معلومات السائق',
  driverName: 'اسم السائق',
  driverType: 'نوع السائق',
  identityCard: 'بطاقة الهوية',
  drivingPermit: 'رخصة القيادة',
  registeredCustomer: 'عميل مسجل',
  agencyClient: 'عميل الوكالة',
  email: 'البريد الإلكتروني',
  open24_7: 'مفتوح 24/7',
  available24_7: 'متاح 24 ساعة في اليوم، 7 أيام في الأسبوع',
  reservedDates: 'التواريخ المحجوزة',
  favorites: {
    loginRequired: 'تسجيل الدخول مطلوب',
    loginRequiredMessage: 'يجب أن تكون مسجلاً للدخول لإضافة السيارات إلى المفضلة. يرجى تسجيل الدخول أو إنشاء حساب لحفظ السيارات المفضلة.',
    addedToFavorites: 'تمت الإضافة للمفضلة',
    removedFromFavorites: 'تم الحذف من المفضلة',
    addToFavorites: 'إضافة للمفضلة',
    removeFromFavorites: 'حذف من المفضلة',
    pageTitle: 'سياراتي المفضلة',
    pageDescription: 'عرض السيارات المفضلة وإدارة تفضيلاتك',
    pageSubtitle: 'السيارات التي حفظتها في المفضلة',
    errorTitle: 'خطأ في تحميل المفضلة',
    emptyTitle: 'لا توجد سيارات مفضلة بعد',
    emptyDescription: 'ابدأ في استكشاف السيارات وأضفها إلى المفضلة بالنقر على أيقونة القلب.',
    browseCars: 'تصفح السيارات',
    count: '{{count}} سيارة مفضلة'
  },
}; 